<template>
  <section class="bg-gray-100 mb-4">
    <div class="header-area relative w-full h-40 flex items-center justify-center bg-theme-color mb-8 mt-0">
      <h2 class="font-bold text-4xl text-white">{{informacion.titulo}}</h2>
    </div>
    <div class="container mx-auto">
      <div class="grid grid-cols-12 gap-5" v-if="speakers[0].length">
        <div class="md:col-span-8 col-span-12 text-center md:text-left px-10 md:px-0">
          <h2 class="text-theme-color font-medium text-4xl pb-4 font-extrabold">Conferencistas</h2>
        </div>
        <div class="md:col-span-4 col-span-12 mx-auto ">
          <router-link tag="button" :to="informacion.link" class="text-white bg-theme-color py-5 px-7 rounded-md text-lg">
            Ver mas >>
          </router-link>
        </div>
      </div>
      <div class="flex justify-around flex-wrap" v-if="speakers[0].length">
        <div class="mt-20 mx-6 flex flex-col items-center" v-for="(speaker, index) in speakers[0]" :key="`${speaker.nombre}-${index}`">
          <div class="w-48 h-48 container-img rounded-full overflow-hidden border-4 border-purple">
            <img class="" :src="speaker.foto" alt="speaker" />
          </div>
          <a :href="speaker.link" target="_blank">
            <strong class="mt-3 text-xl">{{speaker.nombre}}</strong>
          </a>
           <a :href="speaker.link" target="_blank">
            <p class="text-xl">{{speaker.universidad}}</p>
          </a>
          <small class="text-xl">{{speaker.tipo}}</small>
        </div>
      </div>
    </div>

    <div class="container mx-auto mt-8">
      <div class="grid grid-cols-12 gap-5" v-if="speakers[1].length">
        <div class="md:col-span-8 col-span-12 text-center md:text-left px-10 md:px-0">
          <h2 class="text-theme-color font-medium text-4xl pb-4 font-extrabold">Panelistas</h2>
        </div>
        <div class="md:col-span-4 col-span-12 mx-auto ">
          <router-link tag="button" :to="'/invitados/panelistas?evento=1'" class="text-white bg-theme-color py-5 px-7 rounded-md text-lg">
            Ver mas >>
          </router-link>
        </div>
      </div>
      <div class="flex justify-around flex-wrap" v-if="speakers[1].length">
        <div class="mt-20 mx-6 flex flex-col items-center" v-for="(speaker, index) in speakers[1]" :key="`${speaker.nombre}-${index}`">
          <div class="w-48 h-48 container-img rounded-full overflow-hidden border-4 border-purple">
            <img class="" :src="speaker.foto" alt="speaker" />
          </div>
          <a :href="speaker.link" target="_blank">
            <strong class="mt-3 text-xl">{{speaker.nombre}}</strong>
          </a>
           <a :href="speaker.link" target="_blank">
            <p class="text-xl">{{speaker.universidad}}</p>
          </a>
          <small class="text-xl">{{speaker.tipo}}</small>
        </div>
      </div>
    </div>

    <div class="container mx-auto mt-8">
      <div class="grid grid-cols-12 gap-5" v-if="speakers[2].length">
        <div class="md:col-span-8 col-span-12 text-center md:text-left px-10 md:px-0">
          <h2 class="text-theme-color font-medium text-4xl pb-4 font-extrabold">Ponentes</h2>
        </div>
        <div class="md:col-span-4 col-span-12 mx-auto ">
          <router-link tag="button" :to="'/invitados/ponentes?evento=1'" class="text-white bg-theme-color py-5 px-7 rounded-md text-lg">
            Ver mas >>
          </router-link>
        </div>
      </div>
      <div class="flex justify-around flex-wrap" v-if="speakers[2].length">
        <div class="mt-20 mx-6 flex flex-col items-center" v-for="(speaker, index) in speakers[2]" :key="`${speaker.nombre}-${index}`">
          <div class="w-48 h-48 container-img rounded-full overflow-hidden border-4 border-purple">
            <img class="" :src="speaker.foto" alt="speaker" />
          </div>
          <a :href="speaker.link" target="_blank">
            <strong class="mt-3 text-xl">{{speaker.nombre}}</strong>
          </a>
           <a :href="speaker.link" target="_blank">
            <p class="text-xl">{{speaker.universidad}}</p>
          </a>
          <small class="text-xl">{{speaker.tipo}}</small>
        </div>
      </div>
    </div>
    
  </section>
</template>

<script>
export default {
  props: {
    speakers: {
      type: Array,
      default: []
    },
    informacion: {
      type: Object,
      default: null
    }
  },
};
</script>

<style>
</style>
